import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

export default function CookieConsent({ inline = false }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("ipa_cookie_consent")) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);
  const accept = () => {
    localStorage.setItem("ipa_cookie_consent", "1");
    setShow(false);
  };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: inline ? 10 : 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: inline ? 10 : 40 }}
          className={inline ? "relative z-20 mx-4 mt-4 bg-white border border-slate-200 shadow-lg rounded-lg p-4 md:mx-8" : "fixed bottom-20 md:bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40 bg-white border border-slate-200 shadow-2xl rounded-lg p-5"}
          data-testid="cookie-consent"
        >
          <p className="text-sm text-slate-600 leading-relaxed">
            We use essential cookies to make this site work and analytics to improve it. By using
            IndustrialPro Automation you agree to our{" "}
            <Link to="/privacy-policy" className="text-safety font-semibold hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="mt-4 flex gap-3">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="font-head font-bold uppercase tracking-wide text-sm bg-ink text-white px-5 h-10 rounded-full hover:bg-ink-light transition-colors"
            >
              Accept
            </button>
            <button
              onClick={accept}
              data-testid="cookie-dismiss"
              className="font-head font-bold uppercase tracking-wide text-sm text-slate-500 px-3 h-10 hover:text-ink transition-colors"
            >
              Dismiss
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
